// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FT4L","name":"styles_name__2ADH6","phone":"styles_phone__XMLYf"};